import React, {useState} from 'react';
import '../styles/ResearchQuestions.css';
import {QuestionWithYesNo} from "./QuestionWithYesNo";
import {getQuestions} from "../utilities/QuestionBank";
import {submitSurvey} from "../apis/research-api";
import {useHistory} from "react-router-dom";
import { trackPromise } from 'react-promise-tracker';

export const ResearchQuestions = (props) => {
    const history = useHistory();
    const [numberOfQuestionAnswered, setNumberOfQuestionAnswered] = useState(0);

    const [score, setScore] = useState({
        A: {
            point: 0,
            isChecked: false,
            questionIDs: []
        },
        B: {
            point: 0,
            isChecked: false,
            questionIDs: []
        },
        C: {
            point: 0,
            isChecked: false,
            questionIDs: []
        },
        D: {
            point: 0,
            isChecked: false,
            questionIDs: []
        },
        E: {
            point: 0,
            isChecked: false,
            questionIDs: []
        },
        F: {
            point: 0,
            isChecked: false,
            questionIDs: []
        }
    });

    const onChangeHandler = (e) => {
        const {name, value} = e.target;
        const categoryOfQuestion = name.charAt(0);

        /*   let categoryScore = {
               ...score,
               [categoryOfQuestion]: {
                   point: score[categoryOfQuestion].point,
                   isChecked: true,
                   questionIDs: score[categoryOfQuestion].questionIDs.push(name)
               }
           };*/

        if (value === 'Y') {
            const questionIdArray = score[categoryOfQuestion].questionIDs;
            if (!questionIdArray.includes(name)) {
                questionIdArray.push(name);
            }

            const categoryScoreForYes = {
                point: score[categoryOfQuestion].point + 1,
                isChecked: true,
                questionIDs: questionIdArray
            };

            if (score[categoryOfQuestion].isChecked === false && categoryScoreForYes.isChecked) {
                setScore({
                    ...score,
                    [categoryOfQuestion]: categoryScoreForYes
                });
                setNumberOfQuestionAnswered(numberOfQuestionAnswered + 1);
            } else if (score[categoryOfQuestion].isChecked) {
                setScore({
                    ...score,
                    [categoryOfQuestion]: categoryScoreForYes
                });
            }
        } else if (value === 'N') {
            let updatedPoint = score[categoryOfQuestion].point;
            let questionIdArray = score[categoryOfQuestion].questionIDs;

            if (!questionIdArray.includes(name)) {
                questionIdArray.push(name);
            } else {
                questionIdArray = questionIdArray.filter(function (value, index, arr) {
                    return value !== name;
                });
                questionIdArray.push(name);
                updatedPoint = score[categoryOfQuestion].point - 1;
            }

            const categoryScoreForNo = {
                point: updatedPoint,
                isChecked: true,
                questionIDs: questionIdArray
            };

            if (score[categoryOfQuestion].isChecked === false && categoryScoreForNo.isChecked) {
                setScore({
                    ...score,
                    [categoryOfQuestion]: categoryScoreForNo
                })
                setNumberOfQuestionAnswered(numberOfQuestionAnswered + 1);
            } else if (score[categoryOfQuestion].isChecked) {
                setScore({
                    ...score,
                    [categoryOfQuestion]: categoryScoreForNo
                })
            }
        }
    };

    const questions = getQuestions();

    const disableBackground = () => {
        document.getElementById("research-question-container").style.opacity = "0.3"
    }

    const enableBackground = () => {
        document.getElementById("research-question-container").style.opacity = "1"
    }

    const handleSubmitButton = async () => {
        disableBackground();

        const questionLength = [
            score['A'].questionIDs.length,
            score['B'].questionIDs.length,
            score['C'].questionIDs.length,
            score['D'].questionIDs.length,
            score['E'].questionIDs.length,
            score['F'].questionIDs.length,
        ];

        const checkALL = questionLength.every(m => m === 7);
        if (checkALL) {
            const categoryWiseScore = {
                a: score['A'].point,
                b: score['B'].point,
                c: score['C'].point,
                d: score['D'].point,
                e: score['E'].point,
                f: score['F'].point,
            };

            const payload = {
                categoryWiseScore: categoryWiseScore,
                demographicInformation: props.demographicInformation
            };

            const response = await trackPromise(submitSurvey(payload));
            if (response.error === null) {
                window.alert(response.success);
                history.replace('/');
            } else {
                window.alert(response.error);
            }
        } else {
            window.alert('Please fill all fields');
            enableBackground();
        }
    }

    return (
        <div className='research-question-container' id='research-question-container'>
            <h3>Holland's Self-Directed Inventory.</h3>
            <p>Read each statement. If you agree with the statement, fill in the circle.
                There are no wrong answers.</p>

            {
                questions.map(question => (
                    <QuestionWithYesNo
                        key={question.questionNumber}
                        questionNumber={question.questionNumber}
                        researchQuestion={question.researchQuestion}
                        handleOnChange={onChangeHandler}
                        category={question.category}
                    />
                ))
            }

            <button className='next-btn' type='submit' onClick={handleSubmitButton}>
                Submit
            </button>
        </div>
    );
}
